"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cards = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cards = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'cards-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10.5 4C10.5 3.17157 11.1716 2.5 12 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V8C17.5 8.82843 16.8284 9.5 16 9.5H12C11.1716 9.5 10.5 8.82843 10.5 8V4ZM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H8C8.82843 2.5 9.5 3.17157 9.5 4V8C9.5 8.82843 8.82843 9.5 8 9.5H4C3.17157 9.5 2.5 8.82843 2.5 8V4ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H16C16.8284 10.5 17.5 11.1716 17.5 12V16C17.5 16.8284 16.8284 17.5 16 17.5H12C11.1716 17.5 10.5 16.8284 10.5 16V12ZM2.5 12C2.5 11.1716 3.17157 10.5 4 10.5H8C8.82843 10.5 9.5 11.1716 9.5 12V16C9.5 16.8284 8.82843 17.5 8 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16V12ZM4 4V8H8V4H4ZM12 4V8H16V4H12ZM16 12V16H12V12H16ZM4 12V16H8V12H4Z', fill: '#4B5563' })));
};
exports.cards = cards;
